import { postAPI } from "../../api"
import { REACT_APP_CONTRACT } from "../../utils/common"

export async function getIncontractCandidates(tab: string, search: string, body: any) {
    const Details = postAPI( REACT_APP_CONTRACT + `/provider-contracts?tab=${tab}&search=${search}`, body)
    return Details
}
